import { render } from "./common-snackbar.vue?vue&type=template&id=1967cb25&ts=true&lang=pug"
import script from "./common-snackbar.vue?vue&type=script&lang=ts"
export * from "./common-snackbar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__